import { useDispatch, useSelector } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import {
  setPointMap,
  setPointMapStation,
}
  from "../../redux/actions/mapActions";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Button,
} from '@mui/material';
import Swal from "sweetalert2";


export default function InfoSummaryTable({ data }) {

  const dispatch = useDispatch();

  const loadingExcel = useSelector((state) => state.map.loadingExcel);

  const verMapa = () => {
    dispatch(setPointMap(data.results));
    localStorage.setItem("puntosMapa", JSON.stringify(data.results));
    window.open("/mapa-sismicidad", "_blank");
  };

  const verMapStations = () => {
    dispatch(setPointMapStation(data.stations));
    localStorage.setItem("pointsStation", JSON.stringify(data.stations));
    window.open("/map-stations", "_blank");
  };

  const generarExcel = async () => {
    try {
      
      Swal.fire({
        title: "Generando archivo Excel...",
        text: "Por favor espera unos segundos.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
    
      const response = await fetch(
        `${process.env.REACT_APP_EXCEL_URL}/export-excel`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ results: data.results }),
        }
      );
    
      if (!response.ok) {
        throw new Error("Error en la respuesta del servidor");
      }
    
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "sismicidadTecto.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
    
      Swal.fire({
        title: "Archivo generado correctamente",
        text: "El archivo Excel se descargó exitosamente.",
        icon: "success",
        confirmButtonText: "Aceptar",
        confirmButtonColor: "#3085d6",
      });
    
    } catch (error) {
      console.error("Error generando Excel:", error);
      Swal.fire({
        title: "Error generando Excel",
        text: "No fue posible generar el archivo. Por favor, intenta nuevamente.",
        icon: "error",
        confirmButtonText: "Cerrar",
        confirmButtonColor: "#d33",
      });
    } 
  };
  
  const generateKml = async () => {
    const payload = { results: data.results };
  
    try {
      // Mostrar mensaje de carga
      Swal.fire({
        title: "Generando archivo KML...",
        text: "Por favor espera unos segundos.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
    
      const response = await fetch(`${process.env.REACT_APP_EXCEL_URL}/generar_kml`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
    
      if (!response.ok) {
        throw new Error("Error al generar KML");
      }
    
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "kmlMap.kml";
      a.click();
    
      Swal.fire({
        title: "Archivo generado correctamente",
        text: "El archivo KML se descargó exitosamente.",
        icon: "success",
        confirmButtonText: "Aceptar",
        confirmButtonColor: "#3085d6",
      });
    
    } catch (error) {
      console.error("Error generando KML:", error);
      Swal.fire({
        title: "Error generando archivo",
        text: "No fue posible generar el archivo KML. Por favor, intenta nuevamente.",
        icon: "error",
        confirmButtonText: "Cerrar",
        confirmButtonColor: "#d33",
      });
    }
  };
  return (
    <Box display="flex" justifyContent="center" mt={4}>
      <TableContainer
        component={Paper}
        sx={{ maxWidth: 720, border: 1, borderColor: 'divider' }}
      >
        <Table size="small">
          <TableBody>
            <TableRow>
              <TableCell sx={{ border: 1, borderColor: 'divider' }}><strong>Total de registros:</strong></TableCell>
              <TableCell sx={{ border: 1, borderColor: 'divider' }}>{data.lenResults}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ border: 1, borderColor: 'divider' }}><strong>Graficar:</strong></TableCell>
              <TableCell sx={{ border: 1, borderColor: 'divider' }}>
                <Button size="small" variant="outlined" onClick={verMapa}>Ver mapa de sismicidad</Button>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ border: 1, borderColor: 'divider' }}><strong>Generar KML:</strong></TableCell>
              <TableCell sx={{ border: 1, borderColor: 'divider' }}>
                <Button size="small" variant="outlined" onClick={generateKml}> Generar KML </Button>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ border: 1, borderColor: 'divider' }}><strong>Generar Excel:</strong></TableCell>
              <TableCell sx={{ border: 1, borderColor: 'divider' }}>
                {loadingExcel ? (
                  <Box display="flex" flexDirection="column" alignItems="center" p={2}>
                    <CircularProgress size={40} sx={{ color: '#2e7d32' }} />
                    <Box mt={1}>Generando Excel...</Box>
                  </Box>
                ) : (
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={generarExcel}
                  >
                    Generar Excel
                  </Button>
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ border: 1, borderColor: 'divider' }}><strong>Formas de Onda:</strong></TableCell>
              <TableCell sx={{ border: 1, borderColor: 'divider' }}>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => window.open('/formas-onda', '_blank', 'noopener,noreferrer')}
                >
                  Ver formas de onda
                </Button>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ border: 1, borderColor: 'divider' }}><strong>Sfiles:</strong></TableCell>
              <TableCell sx={{ border: 1, borderColor: 'divider' }}>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => window.open('/sfiles', '_blank', 'noopener,noreferrer')}
                >
                  Ver Sfiles
                </Button>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ border: 1, borderColor: 'divider' }}><strong>Archivos de respuesta:</strong></TableCell>
              <TableCell sx={{ border: 1, borderColor: 'divider' }}>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => window.open('/responseFiles', '_blank', 'noopener,noreferrer')}
                >
                  Ver Archivos de Respuesta
                </Button>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ border: 1, borderColor: 'divider' }}><strong>Formas de onda por estación:</strong></TableCell>
              <TableCell sx={{ border: 1, borderColor: 'divider' }}>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => window.open('/waveformsStation', '_blank', 'noopener,noreferrer')}
                >
                  Formas de Onda por Estación
                </Button>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ border: 1, borderColor: 'divider' }}><strong>Ver estaciones de la red regional del Valle <br/>Medio del Magdalena y La Loma Cesár:</strong></TableCell>
              <TableCell sx={{ border: 1, borderColor: 'divider' }}>
                <Button size="small" variant="outlined" onClick={verMapStations} sx={{ mr: 1 }}>Ver mapa </Button>
                <Button
                  size="small"
                  variant="outlined"
                  component="a"
                  href={`${process.env.REACT_APP_EXCEL_URL}/descargar-excel`}
                >
                  Descargar Excel
                </Button>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

